module.exports = __webpack_public_path__ + "images/presentation-2-8f04b174f3526ce00fa3dfcc342aaee7.jpg";